
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"112","height":"112","viewBox":"0 0 97 97","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M96.985 23.972a2.847 2.847 0 00-.628-1.52c-.142-.173 1.306 1.285-21.599-21.62A2.864 2.864 0 0072.748 0H8.525C3.825 0 0 3.824 0 8.525v79.95C0 93.175 3.824 97 8.525 97h79.948C93.174 97 97 93.175 97 88.475c0-68.997.007-64.285-.014-64.503zM65.36 5.684V24.25a2.845 2.845 0 01-2.842 2.842h-3.6V5.684h6.442zm-12.125 0v21.408H26.902a2.845 2.845 0 01-2.842-2.842V5.684h29.176zm12.125 55.13h-41.3v-3.6a2.845 2.845 0 012.841-2.841H62.52a2.845 2.845 0 012.842 2.842v3.6zm-41.3 30.502V66.498h41.3v24.818h-41.3zm67.254-2.841a2.845 2.845 0 01-2.841 2.841h-17.43V57.215c0-4.701-3.824-8.526-8.525-8.526H26.902c-4.7 0-8.525 3.825-8.525 8.526v34.101H8.525a2.845 2.845 0 01-2.841-2.841V8.525a2.845 2.845 0 012.841-2.841h9.852V24.25c0 4.7 3.824 8.525 8.525 8.525H62.52c4.7 0 8.525-3.824 8.525-8.525V5.684h.528l19.743 19.743v63.048z","fill":"#52B788"}})])
          )
        }
      }
    